import { IResponse } from "..";
import client from "../client";

export interface IFile {
  id: string;
  name: string;
  tenantId: string;
  projectId: string;
  parentId: string; // check if null required
  size: number;
  contentType: string;

  isVisible: boolean;
  status: string;
  metadata: any;

  createdBy: string;
  role: 'MAIN' | 'STEMS' | 'ARTWORK' | 'MASTER';

  createdAt: string;
  updatedAt: string;
}

export interface INewFile {
  name: string;
  tenantId: string;
  projectId?: string;
  size?: number;
  role: string;
  parentId?: string;
  status?: string;
  metadata?: any;
  contentType: string;
}

export interface IFolder {
  id: string;
  name: string;
  projectId: string;
  parentId: string | null;
}

export interface INewFolder {
  name: string;
  projectId: string;
  parentId: string | null;
}

interface IFilePresignResponse {
  fileId: string;
  presignedUrl: string;
}

async function getFilesByProject(projectId: string) {
  return client.get<IResponse<IFile[]>>(`/file/project:${projectId}`);
}

async function getFile(id: string) {
  return client.get<IResponse<IFile>>(`/file/${id}`);
}

async function getFilePresignedUploadUrl(id: string) {
  return client.put<IResponse<IFilePresignResponse>>(`/file/${id}/presign`);
}

async function getFilePresignedDownloadUrl(id: string, tenantId: string) {
  return client.get<IResponse<IFilePresignResponse>>(`/file/${id}/presign`, {
    headers: {
      "X-TENANT": tenantId
    }
  });
}

async function addFile(file: INewFile) {
  return client.post<IResponse<IFile>>(`/file`, file);
}

async function deleteFile(id: string) {
  return client.delete<IResponse<IFile>>(`/file/${id}`);
}

async function updateFilePartially(fileId: string, file: Partial<IFile>) {
  return client.patch<IResponse<IFile>>(`/file/${fileId}`, file);
}

// Folder
async function getFoldersByProject(projectId: string) {
  return client.get<IResponse<IFolder[]>>(`/folder/project:${projectId}`);
}

async function addFolder(folder: INewFolder) {
  return client.post<IResponse<IFile>>(`/folder`, folder);
}

async function deleteFolder(id: string) {
  return client.delete<IResponse<IFile>>(`/folder/${id}`);
}

async function updateFolderPartially(
  folderId: string,
  folder: Partial<IFolder>
) {
  return client.patch<IResponse<IFolder>>(`/folder/${folderId}`, folder);
}

const api = {
  getFilesByProject,
  getFile,
  addFile,
  deleteFile,
  getFilePresignedDownloadUrl,
  getFilePresignedUploadUrl,
  updateFilePartially,
  getFoldersByProject,
  addFolder,
  deleteFolder,
  updateFolderPartially,
};

export default api;
